import styled from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import {Label1, Label2, Label4} from "@irati/ui/src/Labels"

export const StyledCard = styled(Card)`
  position: relative;
  margin-bottom: 10px;
`

export const CurrentSession = styled(Label4)`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 5px;
  margin-right: 5px;
`

export const Flex = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
`

export const FlexLeft = styled.div`
  ${Label1}, ${Label2}, ${Label4} {
    display: block;
  }
`

export const FlexRight = styled.div`
  align-self: center;
`
